import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { fontBold } from 'style/styled-components/cssGlobalVariables';
import { Breakpoints, MQ } from 'style/styled-components/cssMediaQueries';
import { hexToRgba } from 'utils/fnColors';

export const landscapeCardWidthMobile = 328;
export const landscapeCardMinHeightMobile = 280;

export const landscapeCardWidth = 224;
export const landscapeCardMinHeight = 260;

export const landscapeCardHoveredWidth = 320;
export const landscapeCardHoveredHeight = 264;

export const landscapeInfoWrapperMinHeight = 97;

export const animationType = 'ease-in-out';
export const animationDuration = '150ms';
export const animationDelay = '150ms';

export const InfoWrapper = styled.div`
    width: 100%;
    flex: 1;
    padding: 8px 16px 16px 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    transition:
        min-height ${animationDuration} ${animationType} ${animationDelay},
        padding ${animationDuration} ${animationType} ${animationDelay};
`;

export const Title = styled.p`
    color: var(--color-primary);
    font-size: 14px;
    line-height: 1.4;
    font-family: ${fontBold};
    text-align: center;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export const SubscriptionType = styled.p`
    color: var(--color-dark-body-70);
    font-size: 12px;
    line-height: 1.33;
    text-align: center;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
    margin-bottom: 8px;
`;

export const SubscriptionPricing = styled.p`
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    font-size: 16px;
    line-height: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    clear: both;
    text-align: center;
`;

export const PricingWrapper = styled.div`
    margin-top: auto;
`;

export const PriceValue = styled.span`
    font-family: ${fontBold};
    font-weight: 700;
    font-size: 16px;
`;

export const CurrencyAndDuration = styled.span`
    font-weight: 400;
    font-size: 14px;
    color: var(--color-dark-body-70);
`;

export const ImageWrapper = styled.div`
    height: 184px;
    width: 100%;
    position: relative;
    overflow: hidden;
    border-radius: 4px 4px 0 0;

    ${MQ(Breakpoints.s)} {
        height: 125px;
    }

    img {
        width: 100%;
    }
`;

export const MarkerLabel = styled.div`
    background: var(--color-accent-dark);
    border-radius: 2px;
    position: absolute;
    right: 8px;
    top: 8px;
    display: flex;
    padding: 2px 6px;
    align-items: flex-start;
    gap: 4px;
    color: white;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    z-index: 2;
`;

export const CardLandscapeWrapper = styled.div`
    background: var(--Background-tertiary, #2e2f42);
    width: 100%;
    height: 100%;
    min-height: inherit;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0 4px 8px ${(props) => hexToRgba(props.theme.brandedConfig.black_color, 0.05)};
    display: flex;
    flex-direction: column;
`;

export const CardWrapper = styled.div`
    display: inline-block;
    position: relative;
    width: ${landscapeCardWidthMobile}px;
    min-height: ${landscapeCardMinHeightMobile}px;
    margin-left: 8px;
    margin-right: 8px;
    margin-bottom: 24px;
    border-radius: 8px;
    transition: transform ${animationDuration} ${animationType};

    &:hover {
        outline: none;

        &::before {
            content: '';
            position: absolute;
            top: -5px;
            left: -5px;
            right: -5px;
            bottom: -5px;
            border: 2px solid white;
            border-radius: 8px;
            pointer-events: none;
            z-index: 1;
            opacity: 1;
        }
    }

    &:focus-visible {
        outline: var(--focus-outline);
    }

    ${MQ(Breakpoints.s)} {
        width: ${landscapeCardWidth}px;
        min-height: 222px;
        height: 100%;
        margin-bottom: 8px;
    }
`;
